// Marks a required field as "touched" the first time it's blurred, so
// theme.css's red/invalid or green/valid border styling only ever
// appears after the user has actually interacted with a field — never
// on page load, before anyone's typed anything (an explicit, deliberate
// choice, not an oversight — showing a wall of red errors before
// someone's even started filling out a form is a well-known bad
// pattern). One global listener here, via event delegation on the
// capture phase (blur doesn't bubble, so a regular bubble-phase
// listener on document wouldn't see it at all), covers every required
// field across the entire app from a single place — no need to add an
// onBlur handler to each of the many existing form inputs individually.
// Imported once, for its side effect only, from main.jsx.
document.addEventListener(
  "blur",
  (e) => {
    if (e.target && e.target.matches && e.target.matches("input[required], select[required], textarea[required]")) {
      e.target.classList.add("touched");
    }
  },
  true
);
